// トップ(/)と同じヘッダー動作を他ページでも行うため、mall配下の処理をベースに記述
const setVariable = () => {
  const header = document.querySelector('.category-shop-page-header');
  if (header) {
    const headerHeight = header.clientHeight;
    // ヘッダーの上部に余白があるため+5しておく
    document.documentElement.style.setProperty('--header-height', `${headerHeight+5 / 1}px`);
  }
};

const showMenu = () => {
  // for small viewport (max-width: 1250px)
  const handleSmallViewport = () => {
    const $accScpEl = $('.js-menu-scope');
    const $accTgrEl = $('.js-menu-tgr');
    const $accTgtEl = $('.js-menu-tgt');

    $($accTgtEl).hide();

    function accordion() {
      $($accScpEl).not($(this)).find($accTgrEl).siblings($accTgtEl).slideUp();
      $($accScpEl).not($(this)).find($accTgrEl).removeClass('is-active');
      $(this).find($accTgrEl).toggleClass('is-active');
      $(this).find($accTgrEl).siblings($accTgtEl).stop().slideToggle();
    }

    if ($accScpEl.length) {
      $($accScpEl).off('click', accordion); // 既存のイベントリスナーを削除
      $($accScpEl).on('click', accordion);
    }
  };

  // for large viewport (max-width: 1250px)
  const handleLargeViewport = () => {
    const body = document.body;
    const ddlScopeEls = document.querySelectorAll('.js-menu-scope');
    if (ddlScopeEls) {
      ddlScopeEls.forEach((ddlScopeEl) => {
        const ddlTgrEl = ddlScopeEl.querySelector('.js-menu-tgr');
        const ddlTgtEl = ddlTgrEl.nextElementSibling;

        function ddlOpen() {
          body.classList.add('add-filter');
          ddlTgtEl.classList.add('is-show');
        }

        function ddlClose() {
          body.classList.remove('add-filter');
          ddlTgtEl.classList.remove('is-show');
        }

        ddlScopeEl.removeEventListener('mouseover', ddlOpen);
        ddlScopeEl.removeEventListener('mouseout', ddlClose);

        ddlScopeEl.addEventListener('mouseover', ddlOpen);
        ddlScopeEl.addEventListener('mouseout', ddlClose);
      });
    }
  };

  // 初期状態のチェック
  if (window.matchMedia("(max-width: 1250px)").matches) {
    handleSmallViewport();
  } else {
    handleLargeViewport();
  }

  // リサイズ時の対応
  window.addEventListener('resize', () => {
    if (window.matchMedia("(max-width: 1250px)").matches) {
      handleSmallViewport();
    } else {
      handleLargeViewport();
    }
  });
};

// ページロード時に呼び出す
document.addEventListener('DOMContentLoaded', () => {
  setVariable();
  showMenu();
});